export default function FinalCTA() {
  const otherIdahoCities = [
    { name: "Idaho Falls", href: "/idaho-falls" },
    { name: "Coeur d'Alene", href: "/coeur-dalene" },
    { name: "Meridian", href: "/meridian" },
    { name: "Nampa", href: "/nampa" },
  ];

  return (
    <footer>
      <section className="bg-[#1A365D] py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Get Started Today</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Get Your Boise Passport?
          </h2>
          <p className="text-white/70 text-base leading-relaxed mb-8 max-w-xl mx-auto">
            Don&apos;t risk delays or a 700-mile trip to Seattle. Fast Passport Center handles everything — from document review to agency submission — so you can focus on your trip.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport Now
            </a>
            <a
              href="tel:8772530084"
              className="border border-white/30 hover:border-[#F6C344] text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
            >
              Call 877-253-0084
            </a>
          </div>

          <div className="border-t border-white/10 pt-8">
            <p className="text-white/40 text-xs mb-4">Other Idaho Cities We Serve</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              {otherIdahoCities.map((c, i) => (
                <a
                  key={i}
                  href={c.href}
                  className="text-white/60 hover:text-[#F6C344] text-sm font-medium transition-colors whitespace-nowrap"
                >
                  {c.name}
                </a>
              ))}
              <a href="/states/idaho" className="text-white/60 hover:text-[#F6C344] text-sm font-medium transition-colors whitespace-nowrap">
                All Idaho Cities
              </a>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-[#0F2440] py-6">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Fast Passport Center. All rights reserved. Registered U.S. Department of State Passport Courier.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://fastpassportcenter.com/privacy-policy/" className="text-white/40 hover:text-white/70 text-xs transition-colors whitespace-nowrap">Privacy Policy</a>
            <a href="https://fastpassportcenter.com/terms-of-service/" className="text-white/40 hover:text-white/70 text-xs transition-colors whitespace-nowrap">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}